import React, { Fragment } from 'react';
import Cart from './Cart';
import { translate } from '../Services/translation';

const CheckoutCart = ({ errors }) => {
    return (
        <Fragment>
            <div className="row">
                <h3 className="checkout__section-pre-title">1/4</h3>
                <h3 className="checkout__section-title">
                    {translate('checkout.cart.title')}
                </h3>
            </div>
            <div className="row">
                {errors && errors['cart'] && (
                    <p className="checkout__validator--error">
                        {errors['cart'][0]}
                    </p>
                )}
            </div>
            <Cart />
        </Fragment>
    );
};

export default CheckoutCart;
